const MASK_CHAR = '•'
const LOCAL_MASK = MASK_CHAR.repeat(5)
const DOMAIN_MASK = MASK_CHAR.repeat(3)

// keeps up to 2 leading chars, but never the whole text (a 1 char text is fully hidden)
const visiblePrefix = (text: string) => text.slice(0, Math.min(2, text.length - 1))

/**
 * Masks an email to be shown on screen: `nicolas@gmail.com` -> `ni•••••@gm•••.com`.
 * The mask has a fixed length so it does not leak the length of the original.
 * Returns undefined when it is not a usable email.
 */
export const maskEmail = (email?: string): string | undefined => {
  const value = email?.trim()
  if (!value) return undefined
  const at = value.lastIndexOf('@')
  const local = value.slice(0, at)
  const domain = value.slice(at + 1)
  const dot = domain.indexOf('.')
  if (at < 1 || dot < 1) return undefined
  const domainName = domain.slice(0, dot)
  const tld = domain.slice(dot)
  return `${visiblePrefix(local)}${LOCAL_MASK}@${visiblePrefix(domainName)}${DOMAIN_MASK}${tld}`
}
